import { render, staticRenderFns } from "./LandingNavBar.vue?vue&type=template&id=5b25f1f2&scoped=true&"
import script from "./LandingNavBar.vue?vue&type=script&lang=js&"
export * from "./LandingNavBar.vue?vue&type=script&lang=js&"
import style0 from "./LandingNavBar.vue?vue&type=style&index=0&id=5b25f1f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b25f1f2",
  null
  
)

export default component.exports